import React, { Component, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './protectedRoutes';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Whitelist from '../pages/Whitelist';
import Resubmissions from '../pages/Resubmissions'; 
import Ramps from '../pages/Ramps';
import IuguOnboarding from '../pages/IuguOnboarding';

class AppRoutes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={''}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />

            <Route path="/dashboard" element={<PrivateRoute />}>
              <Route path="" element={<Dashboard />} />
            </Route>

            <Route path="/whitelist" element={<PrivateRoute />}>
              <Route path="" element={<Whitelist />} />
            </Route>

            <Route path="/resubmissions" element={<PrivateRoute />}>
              <Route path="" element={<Resubmissions />} />
            </Route>

            <Route path="/ramps" element={<PrivateRoute />}>
              <Route path="" element={<Ramps />} />
            </Route>

            <Route path="/iugu-onboarding" element={<PrivateRoute />}>
              <Route path="" element={<IuguOnboarding />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default AppRoutes;